export function registrationNumberFormatter(
  registrationNumber: string
): string {
  try {
    const masked = registrationNumber
      .replace(/\D+/g, "")
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
    return masked;
  } catch (_) {
    console.log("[DEBUG] - Error formatting registration number", { _ });
    return registrationNumber;
  }
}
